import { GalleryNavDirectionType } from '@interface/common';

export const PREV: GalleryNavDirectionType = 'previous';
export const NEXT: GalleryNavDirectionType = 'next';
